/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Lns, LnsInterface } from "../Lns";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "LSP8CannotSendToAddressZero",
    type: "error",
  },
  {
    inputs: [],
    name: "LSP8CannotUseAddressZeroAsOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "LSP8InvalidTransferBatch",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "LSP8NonExistentTokenId",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "LSP8NotTokenOperator",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "LSP8NotTokenOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenReceiver",
        type: "address",
      },
    ],
    name: "LSP8NotifyTokenReceiverContractMissingLSP1Interface",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenReceiver",
        type: "address",
      },
    ],
    name: "LSP8NotifyTokenReceiverIsEOA",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "LSP8TokenIdAlreadyMinted",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "AuthorizedOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "value",
        type: "bytes",
      },
    ],
    name: "DataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newPrice",
        type: "uint256",
      },
    ],
    name: "PriceChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "RevokedOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "vantiyName",
        type: "bytes32",
      },
    ],
    name: "VanityNameSet",
    type: "event",
  },
  {
    inputs: [],
    name: "allTokenHolders",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "authorizeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "freeze",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keys",
        type: "bytes32[]",
      },
    ],
    name: "getData",
    outputs: [
      {
        internalType: "bytes[]",
        name: "values",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "getOperatorsOf",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "isOperatorFor",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "revokeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "_keys",
        type: "bytes32[]",
      },
      {
        internalType: "bytes[]",
        name: "_values",
        type: "bytes[]",
      },
    ],
    name: "setData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "vanityName",
        type: "bytes32",
      },
    ],
    name: "setVanityName",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
    ],
    name: "tokenIdsOf",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "tokenOwnerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "bytes32[]",
        name: "tokenId",
        type: "bytes32[]",
      },
      {
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "transferBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unFreeze",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newPrice",
        type: "uint256",
      },
    ],
    name: "updatePrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Lns__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    name: string,
    symbol: string,
    _price: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Lns> {
    return super.deploy(name, symbol, _price, overrides || {}) as Promise<Lns>;
  }
  getDeployTransaction(
    name: string,
    symbol: string,
    _price: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(name, symbol, _price, overrides || {});
  }
  attach(address: string): Lns {
    return super.attach(address) as Lns;
  }
  connect(signer: Signer): Lns__factory {
    return super.connect(signer) as Lns__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LnsInterface {
    return new utils.Interface(_abi) as LnsInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Lns {
    return new Contract(address, _abi, signerOrProvider) as Lns;
  }
}
